<template>
    <div :key="key">
        <b-input
            ref="question"
            v-model="form.question"
            size="sm"
            :class="reactiveClass"
            @change="savePoint"
        />
    </div>
</template>

<script>
import TableFormHandler from '../../../../../common/mixins/TableFormHandler'

export default {
    name: 'QuestionForm',

    mixins: [TableFormHandler],

    props: {
        point: {},
    },

    created() {
        this.align = 'left'
    },

    methods: {
        async savePoint() {
            try {
                await axios.put(
                    `/pendingPoints/${this.point.id}/question`,
                    this.form
                )
                this.handleSuccess()
            } catch (error) {
                this.handleError()
                console.log(error)
            }
        },

        initForm() {
            this.form.question = this.point.question
        },

        setInitialKey() {
            this.key = `question${this.point.id}`
        },

        unFocus() {
            this.$refs.question.blur()
        },
    },
}
</script>

<style scoped>
.form-control-sm {
    height: 20px !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    font-size: 12px;
}
</style>
